module.exports = __webpack_public_path__ + "static/media/HCMM425.b36ca816.jpg";